import { Component, Input, OnInit } from '@angular/core';
import { VersionDetail } from './version-detail.model';
import { VersionDetailsService } from './version-details.service';

@Component({
  selector: 'app-version-details',
  templateUrl: './version-details.component.html',
  styleUrls: ['./version-details.component.scss']
})
export class VersionDetailsComponent implements OnInit {
  @Input() public currentVersion: string = "";

  public versionDetails: VersionDetail[] = [];
  public versions: string[] = [];

  constructor(
    private versionDetailsService: VersionDetailsService
  ) { }
  async ngOnInit(): Promise<void> {
    this.versionDetails = await this.versionDetailsService.load(this.versionDetailsService.defaultOptions);
    this.loadVersions();
  }

  public loadVersions() {
    this.versions = [];
    var version = "";
    this.versionDetails.forEach((detail: VersionDetail) => {
      if (version != detail.Version) {
        version = detail.Version;
        this.versions.push(detail.Version);
      }
    });
  }

  public changeVersionDetail(version: string) {
    this.currentVersion = version;
    this.loadVersions();
  }
}
